import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import { AppInstallerContent } from './AppInstallerContent';
import '@wix/design-system/styles.global.css';
import { InstallerRenderControlProvider } from './context/InstallerRenderControlContext';
export const AppInstaller = _ref => {
  let {
    messagesPromise: _messagesPromise,
    preInstallationDataCache: _preInstallationDataCache,
    ...props
  } = _ref;
  const [retryInstallationCount, setRetryInstallationCount] = useState(0);
  const {
    messagesPromise,
    preInstallationDataCache
  } = retryInstallationCount > 0 ? {} // dont use cache when retrying installation
  : {
    messagesPromise: _messagesPromise,
    preInstallationDataCache: _preInstallationDataCache
  };
  return /*#__PURE__*/React.createElement(React.Fragment, {
    key: retryInstallationCount
  }, /*#__PURE__*/React.createElement(InstallerRenderControlProvider, {
    panoramaClient: props.panoramaClient,
    appId: props.appId,
    retryInstallationCount: retryInstallationCount,
    setRetryInstallationCount: setRetryInstallationCount,
    essentials: props.essentials,
    onUiInitialLoad: props.onUiInitialLoad,
    messagesPromise: messagesPromise,
    topology: props.topology,
    errorOnLoginRedirect: props.errorOnLoginRedirect
  }, /*#__PURE__*/React.createElement(AppInstallerContent, _extends({}, props, {
    preInstallationDataCache: preInstallationDataCache
  }))));
};
//# sourceMappingURL=AppInstaller.js.map